<template>
    <div class="profess">
        <h4>
            请输入专业检索表达式
            <span class="errorInfo" v-if="errorMessage">{{errorMessage}}</span>
        </h4>
        <textarea placeholder="请在此输入" v-model="textareaKeyword"></textarea>
        <div class="tips">
            <a href="/expression.pdf" target="_blank">检索表达式语法</a>
        </div>
        <!-- <div class="date-p">
            发表时间: 从 <a-date-picker placeholder="选择日期" /> 到 <a-date-picker placeholder="选择日期" />
        </div> -->
        <div class="btns" style="position: static;margin-top: 40px;">
            <a href="javascript:" class="reset" style="text-decoration: underline" @click="reset">重置</a>
            <router-link to="#" class="search" @click.native="professSearch">检索</router-link>
        </div>
        <div class="tips-text">
            示例：<br/>
            例子 1：查人物<br/>
            TY=P and RE=周作人 and NP=浙江<br/>
            可检索出籍贯为浙江的与周作人有关系的人物。<br/>
            例子 2：查文献<br/>
            PL=浙江 and IS>1840 and DT=JP<br/>
            可检索出 1840 年后出版的，谱籍地是浙江家谱。<br/>
            例子 3：人物文献的组合查询<br/>
            DT=GJ and (CO.FN='赵 or CO.FN=钱) and CO.GE=男 and CO.NP=浙江<br/>
            可检索出责任者为浙江赵姓或钱姓男性的相关古籍文献。
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isResultSearch:{
            default:false
        }
    },
    data() {
        return {
            textareaKeyword: "",
            errorMessage: "",
        }
    },
    methods: {
        reset(){ // 重置检索框内容
            this.textareaKeyword = "";
        },
        professSearch(){ // 专业检索
            this.getDhcCheckexp();
        },
        getDhcCheckexp: async function(){
            let expParams = {
                'exp': this.textareaKeyword
            }
            // console.log(expParams);
            await this.$axios.post(this.Common.getDhcCheckexpUrl, expParams)
            .then((res) => {
                let resultData  = res.data;
                this.errorMessage = resultData.errorMessage;
                if(resultData.errorCode == 0){
                    let professParams = {
                        searchType: 3,
                        datas: resultData.datas, 
                        expParams: this.textareaKeyword
                    }
                    if(this.isResultSearch) this.$emit('professSearch2', professParams);
                    else this.$router.push({ name:"searchResult", params: {
                        searchType: 3, 
                        professParams: JSON.stringify(professParams)
                    } });
                }
            })
            .catch((err) => {
                console.log(err)
            });
        }
    }
}
</script>

<style lang="less" scoped>
    .profess{
        padding: 0 40px;
        h4{
            font-size: 20px;
            color: #1473a5;
            line-height: 1.4;
            margin-bottom: 10px;
            .errorInfo{
                color: red;
                font-size: 14px;
            }
        }
        textarea{
            background: #f7f8f8;
            border: 1px solid #999;
            color: #666464;
            width: 100%;
            height: 105px;
            padding: 5px 10px;
            border-radius: 10px;
            resize: none;
        }
        .tips{
            margin: 5px 0;
            text-decoration: underline;
            a{
                color: #1473a5;
            }
        }
        .tips-text{
            margin-top: 20px;
            font-size: 14px;
            line-height: 1.5;
            color: #1473a5;
        }
        .date-p{
            margin-top: 20px;
            display: flex;
            align-items: center;
            /deep/ .ant-calendar-picker{
                margin: 0 10px;
                background: #f7f8f8;
                border: 1px solid #666464;
                color: #666464;
                height: 32px;
                border-radius: 10px;
                input{
                    background: none;
                    line-height: 28px;
                    outline: none;
                    border: none;
                }
            }
        }
    }
</style>
